import { cn } from "@dc/ui/lib/utils";
import type { ReactNode } from "react";
import { AuthVideoPanel } from "@/components/AuthVideoPanel/AuthVideoPanel";

type AuthSplitLayoutVariant = "login" | "transitional";

interface AuthSplitLayoutProps {
  children: ReactNode;
  variant?: AuthSplitLayoutVariant;
}

const viewportClasses: Record<AuthSplitLayoutVariant, string> = {
  login: "h-dvh w-dvw",
  transitional: "h-[100dvh] w-[100dvw]",
};

export function AuthSplitLayout({ children, variant = "login" }: AuthSplitLayoutProps) {
  return (
    <div className={cn("flex flex-col font-geist md:flex-row", viewportClasses[variant])}>
      <section className="flex min-h-0 flex-1 items-start justify-center overflow-y-auto p-8">
        <div className="my-auto w-full max-w-md">{children}</div>
      </section>
      <AuthVideoPanel />
    </div>
  );
}
